import { CutNode } from './const';
const getAttrs = (tok) => (tok.attrs ? Object.fromEntries(tok.attrs) : {});
export const fromYfm = {
    [CutNode.Cut]: { name: CutNode.Cut, type: 'block', getAttrs },
    [CutNode.CutTitle]: { name: CutNode.CutTitle, type: 'block' },
    [CutNode.CutContent]: { name: CutNode.CutContent, type: 'block' },
};
